//@flow

import Dispatcher from "./Dispatcher";
// import Store from "./store.js";
import { AudioSource } from "../components/audioplayer-v2/source";
// import { Actions  } from "../../services/actions";

const ActionTypes = {
  SET_PLAY_STATE: "SET_PLAY_STATE",
  SET_DESIRED_PLAY_STATE: "SET_DESIRED_PLAY_STATE",
  // SET_IS_BUFFERING: "SET_IS_BUFFERING",
  SET_HIDE_PANEL: "SET_HIDE_PANEL",
  // SET_CURRENT_AUDIO_NAME: "SET_CURRENT_AUDIO_NAME",
  SET_CURRENT_TIME: "SET_CURRENT_TIME",
  SET_DURATION: "SET_DURATION",
  SET_CURRENT_SRC: "SET_CURRENT_SRC",
  SET_IS_MUTED: "SET_IS_MUTED",
  SET_VOLUME: "SET_VOLUME",
  TOGGLE_PLAY: "TOGGLE_PLAY",
};

// let staleTimer: TimeoutID;

const Actions = {
  togglePlay() {
    console.log("toggle play");
    Dispatcher.dispatch({
      type: ActionTypes.TOGGLE_PLAY,
    });
  },
  setDesiredPlayState(v: boolean) {
    // console.log("toggle play")
    Dispatcher.dispatch({
      type: ActionTypes.SET_DESIRED_PLAY_STATE,
      value: v,
    });
  },
  setAutoplayPrevented(o: boolean) {
    console.error(o, "setAutoplayPrevented not handled");
  },
  setIsMuted(b: boolean) {
    window.controls.setMuted(b);

    Dispatcher.dispatch({
      type: ActionTypes.SET_IS_MUTED,
      value: b,
    });
  },
  setVolume(e: number) {
    // window.controls.setVolume(b);
    const v = e * e * 0.0001;
    window.audioRef.current.volume = v;
    Dispatcher.dispatch({
      type: ActionTypes.SET_VOLUME,
      value: e,
    });
  },
  setCurrentSrc(d: AudioSource) {
    // console.log(d);
    Dispatcher.dispatch({ type: ActionTypes.SET_CURRENT_SRC, value: d });
  },
  setDuration(d: number) {
    Dispatcher.dispatch({ type: ActionTypes.SET_DURATION, value: d });
  },
  setCurrentTime(s: number) {
    Dispatcher.dispatch({ type: ActionTypes.SET_CURRENT_TIME, value: s });
  },
  // setCurrentAudioName(s : Array<string>) {
  //   Dispatcher.dispatch({type: ActionTypes.SET_CURRENT_AUDIO_NAME, value: s});
  // },
  setPlayState(b: string) {
    Dispatcher.dispatch({ type: ActionTypes.SET_PLAY_STATE, value: b });
  },
  // setIsBuffering(b: boolean) {
  //   Dispatcher.dispatch({ type: ActionTypes.SET_IS_BUFFERING, value: b });
  // },
  setHidePanel(b: boolean) {
    Dispatcher.dispatch({ type: ActionTypes.SET_HIDE_PANEL, value: b });
  },
};

export { Actions, ActionTypes };
